// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-enter[data-v-92ccc730]{opacity:0}.v-enter-active[data-v-92ccc730],.v-leave-active[data-v-92ccc730]{transition:opacity .5s ease}.v-enter-from[data-v-92ccc730],.v-leave-to[data-v-92ccc730]{opacity:0}", ""]);
// Exports
module.exports = exports;
